import styled from "styled-components";

import { colors } from "shared/ui";

export const Hint = styled.div`
    color: ${colors.textSecondary};
    font-size: 13px;
`;
